<life-di-nav></life-di-nav>

<div *ngIf="centerDetail && main_theme">
    <lifedi-learning-center-content [centerDetail]="centerDetail" [theme]="main_theme">
    </lifedi-learning-center-content>
</div>

<div *ngIf="centerDetail && main_theme && allNews && allArticles && allCourse && allWorkshop && allMeasure">
    <div *ngIf="allNews.length > 0" class="container mt-4">
        <div>
            <h2 class="lifedi-color" style="display: inline-block;">ข่าวสาร</h2>
            <a routerLink="/news" style="margin-top: 15px; float: right;">ดูข่าวสารทั้งหมด</a>
        </div>

        <swiper [config]="customOptions" class="swiper-container">
            <ng-template swiperSlide *ngFor="let item of allNews">
                <div class="carousel-wrapper">
                    <lifedi-card-box [routerLink]="item.NEWS_ID ? ['/news', item.NEWS_ID] : []"
                        [title]="item.NEWS_TITAL" [imageUrl]="item.NEWS_PIC" [content]="item.NEWS_DETAIL"
                        [date]="item.NEWS_DATE" [id]="item.NEWS_ID">
                    </lifedi-card-box>
                </div>
            </ng-template>
        </swiper>
    </div><br />

    <div *ngIf="allArticles.length > 0" class="container mt-4">
        <div>
            <h2 class="lifedi-color" style="display: inline-block;">บทความ</h2>
            <a routerLink="/article" style="margin-top: 15px; float: right; display: inline-block;">ดูบทความทั้งหมด</a>
        </div>

        <swiper [config]="customOptions" class="swiper-container">
            <ng-template swiperSlide *ngFor="let at of allArticles">
                <div class="carousel-wrapper">
                    <lifedi-card-box [routerLink]="at.ARTICAL_ID ? ['/article', at.ARTICAL_ID] : []"
                        [title]="at.ARTICAL_TITAL" [imageUrl]="at.ARTICAL_PIC" [content]="at.ARTICAL_DETAIL"
                        [id]="at.ARTICAL_ID"></lifedi-card-box>
                </div>
            </ng-template>
        </swiper>
    </div><br />

    <div *ngIf="allCourse.length > 0" class="container mt-4">
        <div>
            <h2 class="lifedi-color" style="display: inline-block;">คอร์สเรียน</h2>
            <a routerLink="/e-learning" style="margin-top: 15px; float: right;">ดูคอร์สเรียนทั้งหมด</a>
        </div>
        <swiper [config]="customOptions" class="swiper-container">
            <ng-template swiperSlide *ngFor="let c of allCourse">
                <div class="carousel-wrapper">
                    <lifedi-course-card (viewCourse)="viewCourse(c.COURSE_ID)" [title]="c.COURSE_NAME"
                        [imageUrl]="c.COURSE_PIC" [haveFavorite]="false" [teacherName]="c.USERNAME"
                        [price]="c.COURSE_PRICE" [premiumPrice]="c.COURSE_SPECIALPRICE">
                    </lifedi-course-card>
                </div>
            </ng-template>
        </swiper>
    </div><br />

    <div *ngIf="allWorkshop.length > 0" class="container mt-4">
        <div>
            <h2 class="lifedi-color" style="display: inline-block;">กิจกรรม / บริการ</h2>
            <a routerLink="/activity/workshop" style="margin-top: 15px; float: right;">ดูกิจกรรมทั้งหมด</a>
        </div>
        <swiper [config]="customOptions" class="swiper-container">
            <ng-template swiperSlide *ngFor="let w of allWorkshop">
                <div class="carousel-wrapper">
                    <mat-card [routerLink]="'/activity/workshop/' + w.WORKSHOP_ID">

                        <img [src]="w.WORKSHOP_PIC" class="workshopPic" />
                        <img *ngIf="w.WORKSHOP_QTY_LEARNERS <= w.COUNT_REGIS" class="workshopPicFull"
                            src="assets/full.png" />

                        <div style="display: flex; justify-content: flex-end">
                            <mat-card-subtitle class="numRegis">
                                <div class="text-center">
                                    {{ w.COUNT_REGIS }}/{{ w.WORKSHOP_QTY_LEARNERS }}
                                </div>
                            </mat-card-subtitle>
                        </div>

                        <mat-card-title class="text-center">
                            <b class="cut-text">{{ w.WORKSHOP_NAME }}</b>
                        </mat-card-title>

                        <mat-card-subtitle>
                            <span class="text-center">
                                {{ w.WORKSHOP_DATE[0].dateTime[0] | date }} ( {{ w.WORKSHOP_DATE | lengthOfArray }}
                                วัน )
                            </span>
                        </mat-card-subtitle>

                        <mat-card-footer>
                            <div class="d-flex align-items-center" style="padding: 10px 0 0;">
                                <div class="col-2">
                                    <img [src]="w.WORKSHOP_COACH_PIC" class="coachPic" />
                                </div>
                                <div class="col-10 text-left" style="line-height: 1.8;">
                                    {{ w.WORKSHOP_COACH }}
                                </div>
                            </div>
                            <div class="col-12 text-right mb-2">
                                <b style="color: #de5c8e;line-height: 1.8;">
                                    <span *ngIf="w.WORKSHOP_PRICE === 0">ฟรี</span>
                                    <span *ngIf="w.WORKSHOP_PRICE > 0">{{ w.WORKSHOP_PRICE | number}} บาท</span>
                                </b>
                            </div>
                        </mat-card-footer>
                    </mat-card>
                </div>
            </ng-template>
        </swiper>
    </div><br />

    <div *ngIf="allMeasure.length > 0" class="container mt-4">
        <div>
            <h2 class="lifedi-color" style="display: inline-block;">แบบทดสอบ</h2>
            <a routerLink="/measure" style="margin-top: 15px; float: right;">ดูแบบทดสอบทั้งหมด</a>
        </div>

        <swiper [config]="customOptions" class="swiper-container">
            <ng-template swiperSlide *ngFor="let m of allMeasure">
                <div class="carousel-wrapper">
                    <lifedi-measure-card [data]="m"></lifedi-measure-card>
                </div>
            </ng-template>
        </swiper>
    </div><br />

</div>


<lifedi-footer></lifedi-footer>